
export enum LINE_COLUMN {
    Date = 'date',
    AccrualAccount = 'accrual-account',
    DebitAccount = 'debit-account',
    DebitAccountVAT = 'debit-account-vat',
    CreditAccount = 'credit-account',
    CreditAccountVAT = 'credit-account-vat',
    Amount = 'amount',
    Dimensions = 'dimensions',
    Description = 'description',
    Invoice = 'invoice',
    InvoiceDueDate = 'invoice-due-date',
    AccrualDate = 'accrual-date'
}

export const COL_ID = 'data-col-id'